import { useState } from 'react';
import InitFilters from './constants/InitFiltering';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [filterParams, setFilterParams] = useState(null); // useful for export
  const [activeDetailID, setActiveDetailID] = useState(null);
  const [filters, setFilters] = useState(InitFilters);
  const [isTransferOpen, setIsTransferOpen] = useState(false);
  const [targetTransferDelegation, setTargetTransferDelegation] = useState(null);
  const [emptyLabel, setEmptyLabel] = useState('داده‌ای یافت نشد!');
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [showDialog, setShowDialog] = useState(false);
  const [dataDialog, setDataDialog] = useState(null);

  return {
    showDialog, setShowDialog,
    dataDialog, setDataDialog,
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    size,
    setSize,
    activeDetailID,
    setActiveDetailID,
    filters,
    setFilters,
    isTransferOpen,
    setIsTransferOpen,
    targetTransferDelegation,
    setTargetTransferDelegation,
    emptyLabel,
    setEmptyLabel,
    page, setPage
  };
};

export default useCustomHook;
